// FR-008: texto da etapa "escrevendo/montando resultado" varia pela extensão real do
// arquivo (data.output_format) - nem sempre disponível na hora do evento in_progress (ex:
// Skills/sandbox só sabe o formato depois que o arquivo já existe), por isso o fallback
// genérico cobre tanto formato ausente quanto formato não mapeado.
const WRITING_TEXT_BY_FORMAT = {
  docx: 'activityStepWritingDocx',
  xlsx: 'activityStepWritingXlsx',
  pptx: 'activityStepWritingPptx',
  pdf: 'activityStepWritingPdf',
};

function getWritingText(data, tChat) {
  const format = (data.output_format || '').toLowerCase().replace(/^\./, '');
  const key = WRITING_TEXT_BY_FORMAT[format];
  return tChat(key || 'activityStepWritingGeneric');
}

// `withSkillName` (painel x chat): o painel mostra o nome da skill separado,
// numa tag própria abaixo do texto - repetir o nome também no texto ficaria
// redundante. Já o indicador inline do chat não tem essa tag, então precisa do
// nome embutido no próprio texto pra não perder a informação.
export function getActivityStepText(step, tChat, { withSkillName = false } = {}) {
  const { type, status, data = {} } = step;

  if (status === 'error') {
    return data.error_message || tChat('activityStepErrorGeneric');
  }

  switch (type) {
    case 'thinking':
      return tChat('activityStepThinking');
    case 'searching':
      if (!data.site_count) {
        return tChat('activityStepSearchingEmpty');
      }
      return tChat('activityStepSearching', { count: data.site_count });
    case 'skill':
      return withSkillName
        ? tChat('activityStepSkillWithName', { name: data.skill_name })
        : tChat('activityStepSkill');
    case 'analyzing':
      return tChat('activityStepAnalyzing');
    case 'preparing_file':
      return tChat('activityStepPreparingFile');
    case 'done':
      return tChat('activityStepDone');
    case 'writing':
      return getWritingText(data, tChat);
    case 'tool':
      // Chamada individual do agente principal (fora de skill) - mesmo formato
      // usado dentro de data.tools de uma skill (ver UnifiedChat.js, Tarefa 5).
      return data.tool_label || tChat('activityStepWritingGeneric');
    default:
      return tChat('activityStepWritingGeneric');
  }
}
